import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Table } from 'reactstrap';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import AccountMultipleOutlineIcon from 'mdi-react/AccountMultipleOutlineIcon';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Loading from '../../shared/components/custom/Loading';
import FormCard from '../../shared/components/custom/FormCard';
import SegmentsShowcase from './components/SegmentsShowcase';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';
import useModal from '../../shared/hooks/useModal';
import Api from '../../util/api';
import { partial } from '../../util/translation/translation';

const SpotlightSegmentsPage = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [segments, setSegments] = useState([]);
  const p = partial('HighlightBannerPage');
  const s = partial('shared');
  const getSpotlightSegments = async () => {
    setLoading(true);
    try {
      const resSegments = await Api.spotlight.getSegments();
      setSegments(resSegments);
      setLoading(false);
    } catch (err) {
      toast.error(err || p('errorFetchingSlider'));
      setLoading(false);
    }
  };

  const [handleModal, visible, deleteId] = useModal();
  useEffect(() => {
    getSpotlightSegments();
    // eslint-disable-next-line
  }, []);

  const renderSegments = () =>
    segments.map((segment) => (
      <tr key={`segment-${segment.id}`}>
        <td className="table-stack__primary">
          <Link
            to={`/users/segment/edit/${segment.id}`}
            className="font-weight-500"
          >
            {segment.name}
          </Link>
        </td>
        <td data-label={s('description')} className="text-muted">
          {segment.description || '–'}
        </td>
        <td data-label={s('users')}>
          <Link
            to={`/users/segment/edit/${segment.id}?tab=2`}
            className={`qb-chip segment-count${
              segment.users.length ? ' segment-count--on' : ''
            }`}
          >
            <AccountMultipleOutlineIcon size={14} />
            {segment.users.length}
          </Link>
        </td>
        <td className="table-stack__actions">
          <div className="icon-actions justify-content-end">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              title={s('edit')}
              id={`edit-segment-${segment.id}`}
              onClick={() => history.push(`/users/segment/edit/${segment.id}`)}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              title={s('delete')}
              tone="danger"
              id={`delete-segment-${segment.id}`}
              onClick={() => handleModal(segment.id)}
            />
          </div>
        </td>
      </tr>
    ));

  const deleteSegment = async () => {
    setLoading(true);
    try {
      await Api.spotlight.deleteSegment(deleteId);
      handleModal();
      toast.success(p('segmentDeleted'));
      getSpotlightSegments();
    } catch (err) {
      setLoading(false);
      toast.error(err);
    }
  };

  return (
    <>
      <Loading loading={loading} />
      <DeleteModal
        visible={visible}
        handleModal={handleModal}
        type={p('segment')}
        modalAction={deleteSegment}
      />
      <SegmentsShowcase />
      <FormCard
        title={
          <>
            {p('segments')}
            <span className="form-card__count">{segments.length}</span>
          </>
        }
        actions={
          <Link to="/users/segment/create">
            <Button size="sm" color="primary" className="mb-0">
              {p('createSegment')}
            </Button>
          </Link>
        }
        bodyClassName="form-card__body--flush"
        className="mt-3"
      >
        <Table responsive striped className="table--roomy table--stack mb-0">
          <thead>
            <tr>
              <th>{s('name')}</th>
              <th>{s('description')}</th>
              <th>{s('users')}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {renderSegments()}
            {!loading && !segments.length && (
              <tr>
                <td colSpan={4} className="segment-empty">
                  {s('noSegments')}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </FormCard>
    </>
  );
};

export default SpotlightSegmentsPage;
